import React from 'react';

import { useIntl } from 'react-intl-next';
import { useSelector } from 'react-redux';

import { Flex } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';

import {
  getMergeErrorCode,
  getMergeErrorMessage,
} from 'src/redux/pull-request/merge-reducer';

import { BasicMergeChecksList } from '../merge-checks-card';
import { usePollingResults } from '../merge-checks-card/hooks';
import { isCustomCheckRequiredAndFailed } from '../merge-checks-card/utils';

import messages from './pull-request-state-message.i18n';
import {
  StateMessageErrorWrapper,
  StateMessageWrapper,
} from './pull-request-state-message.style';

export const MergeErroredMessage = () => {
  const { formatMessage } = useIntl();
  const mergeErrorMessage = useSelector(getMergeErrorMessage);
  const mergeErrorCode = useSelector(getMergeErrorCode);
  const { data: customMergeChecksData } = usePollingResults();

  const coercedMergeErrorMessage = (mergeErrorMessage || '').trim();
  const coercedMergeErrorCode = (mergeErrorCode || '').trim();

  const onMergeCheckFailures = (customMergeChecksData?.results ?? []).filter(
    result =>
      result.checkType === 'on-merge' &&
      // We need to use isCustomCheckRequiredAndFailed here instead of
      // customCheckResultAllowsMerge because the other function returns false when the check is
      // running. We only want to display the ones that have finished and failed.
      isCustomCheckRequiredAndFailed(result)
  );

  return (
    <StateMessageWrapper>
      <SectionMessage
        appearance={
          coercedMergeErrorCode === 'BUILDS_FINISHED_GO_MERGE'
            ? 'discovery'
            : 'error'
        }
        title={formatMessage(messages.asyncMergePullRequestFailureStateMessage)}
      >
        <StateMessageErrorWrapper>
          {onMergeCheckFailures.length > 0 ? (
            <Flex direction="column" gap="space.050">
              {formatMessage(
                messages.asyncMergePullRequestOnMergeCheckFailureDescription,
                { total: onMergeCheckFailures.length }
              )}
              <BasicMergeChecksList
                customMergeCheckResults={onMergeCheckFailures}
              />
            </Flex>
          ) : (
            coercedMergeErrorMessage
          )}
        </StateMessageErrorWrapper>
      </SectionMessage>
    </StateMessageWrapper>
  );
};
